import React from 'react';
import type {IconName, IconPrefix} from '@fortawesome/fontawesome-common-types';

import {Button, Icon, Text} from '@albert-io/atomic';

interface Props {
  copy: string;
  subtitle?: string;
  icon?: IconName | [IconPrefix, IconName];
  onRetry: () => void;
}

/**
 * Error state with a "Try Again" retry: a bordered panel with an icon badge, copy, and a retry
 * button. Mirrors StudentHomepage's TabEmptyState so error states read consistently across the
 * app. Render this when a fetch failed — distinct from a legitimate empty result.
 */
export const ErrorRetryState = ({
  copy,
  subtitle = 'Something went wrong. Check your connection and try again.',
  icon = ['fal', 'circle-exclamation'],
  onRetry
}: Props) => (
  <div className='flex flex-col items-center justify-center gap-x2 rounded-x1 border border-primary p-x4'>
    <div className='flex h-x8 w-x8 items-center justify-center rounded-full background-bold p-x1-half'>
      <Icon className='text-xxl' color='tertiary' icon={icon} />
    </div>
    <Text color='secondary'>{copy}</Text>
    {subtitle && (
      <Text color='secondary' className='max-w-[48ch] text-center text-balance'>
        {subtitle}
      </Text>
    )}
    <Button color='secondary' variant='outlined' size='s' roundness='pill' onClick={onRetry}>
      Try Again
    </Button>
  </div>
);
